
// axios.defaults.baseURL = "http://192.168.150.100:44344/api"; 
// axios.defaults.baseURL = "https://192.168.0.100:44345/api"; 
// axios.defaults.baseURL = "http://192.168.15.155:44344/api";  
const settingsKey = "ui-settings";
import EasyPlanClient from "./EasyPlanClient";
import router from 'vue-router'
import Vue from 'vue'
//axios.defaults.baseURL = "https://linksnctest.ddns.net:64001/api"; 
const UISettingsHelper= 
    {
        CompanyAlias:"",
        IsChanged:false,
        settings: {
            planner: {
                scrollerSpeed: 2,
                fitVisibleDays: true,
                maxDaysToShow: 6,
                startFromToday: true,
                daysToShow: [1,2,3,4,5],
                operatorsAbsenceReasons: ["Corsi", "Ferie", "Malattia", "Visita"],
                vehiclesAbsenceReasons: ["Fermo", "Manutenzione", "Noleggio"],
                equipmentsAbsenceReasons: ["Collaudo", "Guasto"]
            },
            dayEventViewer: {
                scrollerSpeed: 10,
                maxItemPerPage: 5,

            }
        },
        Configure(companyAlias){
            this.CompanyAlias=companyAlias;
        },
        async Pull(companyAlias, callback = (settings) => { }) {
            console.debug("scarico uisettings");
                try{
                    let res= await EasyPlanClient.Company.PullUISettings(companyAlias)
                
                    console.debug(res); 

                    if(res.data.data){
                        let settings = JSON.parse(res.data.data);
                        this.SetSettings(settings);
                        this.IsChanged=false;
                        this.SaveSettings();
                    }
                        
                    callback(this.settings);
                }catch(error){
                    console.log(error);
                    this.error = EasyPlanClient.GetErrorDescription(
                        error.response.data.errorCode
                    );
                    console.error(
                        "si è verificato un errore (" +
                        error.response.data.errorCode +
                        ")" +
                        this.error
                    );
                    console.error(error);
                }
          
                
        },
        async Push(companyAlias, callback = () => { }) {
            console.debug("carico uisettings");
            try{
               let res= await EasyPlanClient.Company.PushUISettings(companyAlias, JSON.stringify(this.settings));
               console.debug(res);
               this.IsChanged=false;
               callback(this.settings);
            }catch(error){
                console.log(error);
                this.error = EasyPlanClient.GetErrorDescription(
                    error.response.data.errorCode
                );
                console.error(
                    "si è verificato un errore (" +
                    error.response.data.errorCode +
                    ")" +
                    this.error
                );
                console.error(error);
            } 
        },
        SetSettings(settings) {
            this.IsChanged=true;
            this.settings = settings;
        },
        GetSettings() {
            return this.settings;
        },
          LoadSettings() { 

            let jsonSettings = localStorage.getItem(settingsKey);
            let tmpSettings;
            if (jsonSettings !== null) {
                tmpSettings = JSON.parse(jsonSettings);
            }
            if (tmpSettings != undefined) {

                for (let i in this.settings) {
                    if (tmpSettings[i] == undefined)
                        tmpSettings[i] = this.settings[i];
                }
                this.settings = tmpSettings;
            }
        },
        SaveSettings() {
            localStorage.setItem(settingsKey, JSON.stringify(this.settings));
        },
    }

    setInterval(()=>{
        if(UISettingsHelper.CompanyAlias && ! UISettingsHelper.IsChanged)
        UISettingsHelper.Pull(UISettingsHelper.CompanyAlias);
    },1000);
    export default UISettingsHelper;